// extracted by mini-css-extract-plugin
export default {"wrapper":"StepTabs_wrapper__2RAPp","substepsWrapper":"StepTabs_substepsWrapper__tRNUp","substep":"StepTabs_substep__b3Xo3","active":"StepTabs_active__+QMDw"};